import { render, staticRenderFns } from "./VuesticDataTable.vue?vue&type=template&id=588f0989"
import script from "./VuesticDataTable.vue?vue&type=script&lang=js"
export * from "./VuesticDataTable.vue?vue&type=script&lang=js"
import style0 from "./VuesticDataTable.vue?vue&type=style&index=0&id=588f0989&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports